import { render, staticRenderFns } from "./MultipleLineText.vue?vue&type=template&id=6eb0130a&"
import script from "./MultipleLineText.vue?vue&type=script&lang=ts&"
export * from "./MultipleLineText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports